import { Directive } from '@angular/core';

@Directive({
  selector: '[myRedemptionLink]',
  standalone: false,
})
export class MyRedemptionLinkDirective {
  constructor() {}
}
